import { render, staticRenderFns } from "./Attendance.vue?vue&type=template&id=45d5a030&scoped=true"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=45d5a030&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d5a030",
  null
  
)

export default component.exports